import { Api } from '@/api/Api'
import _ from 'lodash'
import { ActionTree } from 'vuex'
import { ResponseArray, RootState } from '../types'
import { blankSalesRepArray } from './constants'
import State, { ISalesRepSearchFilter, ISalesRepresentative } from './types'
import SecurityState from '../security/types'
const api = new Api()

export const actions: ActionTree<State, RootState> = {
  getSalesRep({ commit }, id: string): any {
    commit('salesRepLoading')
    const url = `/sales-rep/${id}`
    const securityState = (this.state as any).security as SecurityState
    return api
      .fetchV2({
        url,
        user: securityState.currentUser,
      })
      .then((response) => {
        if (!response.Successful) {
          commit('salesRepError', response.Message ?? 'Error loading sales rep')
          return null
        }

        commit('salesRepLoaded', response)
        return response
      })
      .catch(({ message }: { message: string | undefined }) => {
        commit('salesRepError', message ?? 'Error loading sales rep')
      })
  },
  getSalesReps(
    { commit },
    searchFilters: ISalesRepSearchFilter,
  ): any {
    const {
      page,
      sortBy,
      sortDesc,
      salesRepNumber = '',
      salesRepName = '',
      filterByHasUsers = false,
      filterByHasPendingPermissions = false,
      city = '',
      state = '',
      postalCode = '',
    } = searchFilters
    commit('salesRepsLoading')
    const pageSize = 10
    const url =
      '/sales-rep?PageSize=' +
      pageSize +
      '&Page=' +
      page +
      '&SortBy=' +
      sortBy +
      '&SortDirection=' +
      (sortDesc ? 'desc' : 'asc') +
      '&salesRepNumber=' +
      salesRepNumber +
      '&salesRepName=' +
      encodeURIComponent(salesRepName ?? '') +
      '&city=' +
      city +
      '&state=' +
      state +
      '&postalCode=' +
      postalCode +
      `&filterByHasUsers=${filterByHasUsers}&filterByHasPendingPermissions=${filterByHasPendingPermissions}`
    const securityState = (this.state as any).security as SecurityState
    return api
      .fetchV2({
        url,
        user: securityState.currentUser,
      })
      .then((response) => {
        const salesReps: ResponseArray<ISalesRepresentative> = _.assign({}, blankSalesRepArray)
        salesReps.loading = false
        salesReps.List = response.List
        salesReps.Page = response.Page
        salesReps.PageSize = response.PageSize
        salesReps.Total = response.Total

        commit('salesRepsLoaded', salesReps)
        commit('salesRepFilterUpdated', searchFilters)
        return salesReps
      })
      .catch(({ message }: { message: string | undefined }) => {
        commit('salesRepError', message ?? 'Error loading sales reps')
        commit('salesRepFilterError')
      })
  },
}
